import React from 'react';
import '../style.css';
import "animate.css/animate.min.css";

export function Footer() {
    return(
    <div style={{backgroundColor: "var(--color-bg-soft)"}}>
    <div className='aboutContents'>
        <div className='footerRow' style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'flex-end', width: '100%', flexWrap: 'wrap', gap: '28px' }}>
          <div style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
            <div className='aboutTitle'>Contact</div>
            <div className='aboutContactList'>
              <a href='mailto:lynkim12@gmail.com' target='_blank' className='aboutContactListItem'><div>lynkim12@gmail.com</div></a>
              <a href='https://www.linkedin.com/in/lynkim12' target='_blank' className='aboutContactListItem'><div>LinkedIn</div></a>
              <a href='https://brunch.co.kr/@lynkim' target='_blank' className='aboutContactListItem'><div>Brunch</div></a>
            </div>
          </div>
          <a href="/portfolio_2026.pdf" download="portfolio_2026.pdf" className='footerDownloadButton' role="button">
            <span>Download Portfolio</span>
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
              <path fillRule="evenodd" clipRule="evenodd" d="M21.2071 11.2929C20.8166 10.9024 20.1834 10.9024 19.7929 11.2929L12.9999 18.0858L12.9999 2.5C12.9999 1.94772 12.5522 1.5 11.9999 1.5C11.4476 1.5 10.9999 1.94772 10.9999 2.5L10.9999 18.0858L4.20703 11.2929C3.81651 10.9024 3.18334 10.9024 2.79282 11.2929C2.40229 11.6834 2.40229 12.3166 2.79282 12.7071L11.2928 21.2071C11.6833 21.5976 12.3165 21.5976 12.707 21.2071L21.2071 12.7071C21.5976 12.3166 21.5976 11.6834 21.2071 11.2929Z" fill="currentColor"/>
            </svg>
          </a>
        </div>
    </div>
    </div>
        );
}
